<!--
frontend-author:bhavya,
backend-author: bhavya,
page-name :AgingDetails.vue,
page-description :Sales by Customer for invoice,
started at : 15-Apr-2019,
edited at :16-Apr-2019.
-->
<!-- Html code for aging details-->
<template>
  <div>
    <b-row class="reports-header px-pad border-bottom" style="height:42px">
      <b-col xl="10" lg="10" md="10" sm="10" class="px-0">
        <GlobalDateRangePicker
          class="pr-3"
          :singleDatePicker="true"
          ref="daterangeupdate"
          v-on:setDateRange="getDateRange($event,datePickerReport)"
          :fromDate="from_date"
          :toDate="to_date"
        />
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown mb-xs">
          <template slot="button-content">
            <span v-if="selectedfilter.filter_name">
              <i class="fa fa-filter la-lg mr-1"></i>
              {{selectedfilter.filter_name}}
            </span>
            <span v-else>
              <i class="la la-cog la-lg mr-1"></i>Customize Report
            </span>
          </template>
          <!-- For filter -->
          <b-dropdown-item v-b-modal.AgingDetailsReport>General</b-dropdown-item>
          <!-- To add columns -->
          <b-dropdown-item v-b-modal.custom_index>Show/hide columns</b-dropdown-item>
          <template v-if="reportsfilter.length>0">
            <b-dropdown-divider />
            <div class="mb-2">
              <span class="pl-4 text-link fw-semi-bold">Your Custom Filters</span>
            </div>
          </template>
          <b-dropdown-item v-for="item in reportsfilter" :key="item.id">
            <div class="d-flex">
              <a
                class="report_button mb-0 w-75 text-truncate"
                @click="runcustomreport(item)"
              >{{ item.filter_name }}</a>
              <i
                class="la la-edit la-lg text-right ml-2 mr-3 ml-auto"
                @click="filterpage = 'update',filteritems=item"
                v-b-modal.savefilterform
              ></i>
              <i
                class="glyphicon glyphicon-trash text-right"
                @click="handlingapprovingmodal({
                  content : 'Are you sure you want to delete this customize filter ?',
                  title : 'Delete customize filter - '+item.filter_name,
                  module:'general/deletecustomfilter',
                  data:JSON.stringify({
                    id : item.filter_id,
                    report_type: $route.meta.title
                  }),
                  RoutePlace:'',
                  isRoute:'false',
                  type: 'delete'
                })"
              ></i>
            </div>
          </b-dropdown-item>
        </b-dropdown>
        <span
          class="btn-link cursor_pointer ml-2 fw-semi-bold"
          v-if="!selectedfilter.filter_id"
          @click="filterpage = 'create',savefilterform()"
        >Save filter</span>
      </b-col>
      <b-col xl="2" lg="2" md="2" sm="2" class="px-0">
        <router-link class="event-link float-right mt-2" :to="{ name : 'Reports'}">
          <i class="la la-remove la-lg text-decoration-none text-dark"></i>
        </router-link>
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown float-right mr-2">
          <template slot="button-content">
            <i class="la la-navicon la-lg"></i>
          </template>
          <b-dropdown-item @click="exportModal()" class="dropdown-no-btn">
            <span class="la la-download mx-2"></span>Export Aging Details
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <div>
      <b-row class="pt-2">
        <b-col lg="12" xl="12" md="12" sm="12" class="px-0">
          <div class="text-center text-normal">
            <p class="mb-1">{{ org_name }}</p>
            <h4 class="fw-semi-bold">Aging Details</h4>

            <p class="text-sm text-muted mb-2">As of {{ getDateFormat(to_date) }}</p>
          </div>
          <div class="table-responsive" id="reportScrollCol">
            <!--  sales by customer Table-->
            <table class="table table-bordered reports-table-border table-no-bordered">
              <!--  sales by customer Table head-->

              <thead class="tbl-col">
                <tr>
                  <th style="width:140px !important" v-if="!$route.query.group_by">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,select_columns:$route.query.select_columns,group_by:$route.query.group_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'created_date'} }"
                    >
                      DATE
                      <small class="text-muted" v-if="label == 'created_date'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:140px !important" v-else>DATE</th>

                  <th style="width:120px !important" v-if="!$route.query.group_by">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,select_columns:$route.query.select_columns,group_by:$route.query.group_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'inv_no'} }"
                    >
                      INVOICE
                      <small class="text-muted" v-if="label == 'inv_no'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th v-else style="width:120px !important">INVOICE</th>
                  <th style="width:110px !important" v-if="!$route.query.group_by">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,select_columns:$route.query.select_columns,group_by:$route.query.group_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'inv_status_name'} }"
                    >
                      STATUS
                      <small class="text-muted" v-if="label == 'inv_status_name'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:110px !important" v-else>STATUS</th>
                  <th style="width:180px !important" v-if="!$route.query.group_by">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,select_columns:$route.query.select_columns,group_by:$route.query.group_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'cus_name'} }"
                    >
                      CUSTOMER
                      <small class="text-muted" v-if="label == 'cus_name'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:180px !important" v-else>CUSTOMER</th>
                  <th
                    style="width:80px !important"
                    class="text-right"
                    v-if="!$route.query.group_by"
                  >
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,select_columns:$route.query.select_columns,group_by:$route.query.group_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'age'} }"
                    >
                      AGE
                      <small class="text-muted" v-if="label == 'age'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:80px !important" class="text-right" v-else>AGE</th>
                  <th
                    style="width:140px !important"
                    class="text-right"
                    v-if="!$route.query.group_by"
                  >
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,select_columns:$route.query.select_columns,group_by:$route.query.group_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'grand_total'} }"
                    >
                      AMOUNT
                      <small class="text-muted" v-if="label == 'grand_total'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:140px !important" class="text-right" v-else>AMOUNT</th>
                  <th
                    style="width:140px !important"
                    class="text-right"
                    v-if="!$route.query.group_by"
                  >
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,select_columns:$route.query.select_columns,group_by:$route.query.group_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'due_amount'} }"
                    >
                      BALANCE
                      <small class="text-muted" v-if="label == 'due_amount'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:140px !important" class="text-right" v-else>BALANCE</th>
                  <!-- Customize column -->
                  <th
                    :class="{'text-right':column.align=='right'}"
                    :style="{'width':column.colWidth+'px !important'}"
                    v-for="(column) in reported_columns"
                    v-if="column.checked == true&&!$route.query.group_by"
                    :key="column.id"
                  >
                    <template v-if=" column.field!='export_due_amount'">
                      <span :style="{'width':column.colWidth+'px !important'}">
                        <router-link
                          class="text-dark text-decoration-none"
                          :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,select_columns:$route.query.select_columns,group_by:$route.query.group_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:column.field} }"
                        >
                          {{ column.title }}
                          <small class="text-muted" v-if="label == column.field">
                            <i
                              :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                              style="font-weight:thinner;"
                            ></i>
                          </small>
                        </router-link>
                      </span>
                    </template>
                    <b-row v-else v-b-tooltip.top :title="column.title">
                      <b-col sm="10" class="pr-0">
                        <router-link
                          class="text-dark text-decoration-none"
                          :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,select_columns:$route.query.select_columns,group_by:$route.query.group_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:column.field} }"
                        >
                          <span class="text">{{ column.title }}</span>
                        </router-link>
                      </b-col>
                      <b-col sm="2" class="pl-0">
                        <small class="text-muted" v-if="label == column.field">
                          <i
                            :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </b-col>
                    </b-row>
                  </th>
                  <th v-else-if="column.checked == true&&$route.query.group_by">
                    <template v-if=" column.field!='export_due_amount'">
                      <span :style="{'width':column.colWidth+'px !important'}">{{ column.title }}</span>
                    </template>
                    <b-row v-else v-b-tooltip.top :title="column.title">
                      <b-col sm="10" class="pr-0">
                        <span class="text">{{ column.title }}</span>
                      </b-col>
                    </b-row>
                  </th>
                  <!-- End of customize column header -->
                </tr>
              </thead>
              <!--  Sales by Customer Table body and data -->

              <template v-if="lists.length == 0">
                <tbody>
                  <tr>
                    <td colspan="7" class="text-center">No data to display</td>
                    <td
                      v-if="reported_columns.length > 0 && show_columns_length > 0"
                      :colspan="parseInt(reported_columns.length) - 0"
                    ></td>
                  </tr>
                </tbody>
              </template>
              <template
                v-else-if="typeof $route.query.group_by != 'undefined' && $route.query.group_by != 0"
              >
                <tbody
                  v-for="group in aging_group_total_amount"
                  :key="group.id"
                  v-if="getPresentValue(lists,$route.query.group_by,group[$route.query.group_by]) == true"
                >
                  <tr style="background:#d6dfe8">
                    <td colspan="5" class="fw-semi-bold" style="border:none">{{ group.group_by }}</td>
                    <td
                      style="border:none"
                      class="text-right fw-semi-bold"
                    >{{ orgCurrencySymbol+" "+Number(group.total_view_value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      style="border:none"
                      class="text-right fw-semi-bold"
                    >{{ orgCurrencySymbol+" "+Number(group.total_due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      v-if="reported_columns.length > 0 && show_columns_length > 0"
                      :colspan="parseInt(reported_columns.length) - 0"
                    ></td>
                  </tr>

                  <!-- {{ group_total_amount }} -->
                  <template
                    v-for="(due_group,group_index) in group_total_amount"
                    v-if="due_group['group_by'] == group['group_by'] && getSecondPresentValue(lists,'due_days',due_group['due_days'],$route.query.group_by,due_group[$route.query.group_by])"
                  >
                    <tr :key="group_index">
                      <td colspan="5" class="fw-semi-bold">{{ due_group.due_days }}</td>
                      <td
                        class="text-right fw-semi-bold"
                      >{{ orgCurrencySymbol+" "+Number(due_group.total_view_value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      <td
                        class="text-right fw-semi-bold"
                      >{{ orgCurrencySymbol+" "+Number(due_group.total_due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                      <td
                        v-if="reported_columns.length > 0 && show_columns_length > 0"
                        :colspan="parseInt(reported_columns.length) - 0"
                      ></td>
                    </tr>
                    <tr
                      v-for="item in lists"
                      v-if="item['due_days'] == due_group['due_days'] && item[$route.query.group_by] == due_group[$route.query.group_by]"
                      :key="item.id+due_group.id"
                    >
                      <td>{{ getDateFormat(item.created_date) }}</td>
                      <td><router-link
                          class="event-link theme-text-color"
                          :to="{ name : 'InvoiceView',params:{id:item.inv_hdr_id}}"
                        >{{ item.inv_no }}</router-link></td>
                      <td>{{ item.inv_status_name }}</td>
                      <td style="width:180px !important">
                        <span class="text">{{ item.cus_name }}</span>
                      </td>
                      <td class="text-right">{{ item.age }}</td>
                      <td
                        class="text-right"
                      ><router-link
                          class="event-link theme-text-color"
                          :to="{ name : 'InvoiceView',params:{id:item.inv_hdr_id}}"
                        >{{ Number(item.grand_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link></td>
                      <td
                        class="text-right"
                      ><router-link
                          class="event-link theme-text-color"
                          :to="{ name : 'InvoiceView',params:{id:item.inv_hdr_id}}"
                        >{{ Number(item.due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link></td>
                      <td
                        :class="{'text-right':column.align=='right'}"
                        :style="{'width':column.colWidth+'px !important'}"
                        v-for="(column) in reported_columns"
                        v-if="column.checked == true"
                        :key="column.id"
                      >
                        <span
                          v-if="column.field=='export_grand_total'||column.field=='export_due_amount'||column.field=='credit_limit'"
                        >
                          {{ getDetails(
                          $AppDetails.currency_details,
                          item.cus_currency,
                          "currency_symbol"
                          )+" "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                        </span>
                        <span
                          v-else-if="column.field=='place_of_supply'"
                        >{{ getDetails($AppDetails.state_details,item.place_of_supply,'state_name')}}</span>
                        <span
                          v-else-if="column.field=='cus_currency'"
                        >{{getDetails($AppDetails.currency_details,item.cus_currency,'currency_name')}}</span>

                        <span
                          v-else-if="column.field=='due_date'"
                        >{{ getDateFormat(item[column.field]) }}</span>
                        <span
                          :class="{'text':column.align=='overflow'}"
                          v-else
                        >{{item[column.field] }}</span>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
              <template v-else>
                <tbody
                  v-for="group in group_total_amount"
                  :key="group.id"
                  v-if="getPresentValue(lists,'due_days',group['due_days']) == true"
                >
                  <tr>
                    <td colspan="5" class="fw-semi-bold">{{ group.due_days }}</td>

                    <td
                      class="text-right fw-semi-bold"
                    >{{ orgCurrencySymbol+" "+Number(group.total_view_value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="text-right fw-semi-bold"
                    >{{ orgCurrencySymbol+" "+Number(group.total_due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      v-if="reported_columns.length > 0  && show_columns_length"
                      :colspan="parseInt(reported_columns.length) - 0"
                    ></td>
                  </tr>
                  <tr
                    v-for="item in lists"
                    :key="item.id"
                    v-if="item['due_days'] == group['due_days']"
                  >
                    <td>{{ getDateFormat(item.created_date) }}</td>
                    <td><router-link
                          class="event-link theme-text-color"
                          :to="{ name : 'InvoiceView',params:{id:item.inv_hdr_id}}"
                        >{{ item.inv_no }}</router-link></td>
                    <td>{{ item.inv_status_name }}</td>
                    <td style="width:140px !important">
                      <span class="text">{{ item.cus_name }}</span>
                    </td>
                    <td class="text-right">{{ item.age }}</td>
                    <td
                      class="text-right"
                    ><router-link
                          class="event-link theme-text-color"
                          :to="{ name : 'InvoiceView',params:{id:item.inv_hdr_id}}"
                        >{{ orgCurrencySymbol+" "+Number(item.grand_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link></td>
                    <td
                      class="text-right"
                    ><router-link
                          class="event-link theme-text-color"
                          :to="{ name : 'InvoiceView',params:{id:item.inv_hdr_id}}"
                        >{{ orgCurrencySymbol+" "+Number(item.due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link></td>
                    <td
                      :class="{'text-right':column.align=='right'}"
                      :style="{'width':column.colWidth+'px !important'}"
                      v-for="(column) in reported_columns"
                      v-if="column.checked == true"
                      :key="column.id"
                    >
                      <span
                        v-if="column.field=='place_of_supply'"
                      >{{ getDetails($AppDetails.state_details,item.place_of_supply,'state_name')}}</span>
                      <span
                        v-else-if="column.field=='cus_currency'"
                      >{{getDetails($AppDetails.currency_details,item.cus_currency,'currency_name')}}</span>
                      <span v-else-if="column.field=='export_grand_total'">
                        {{ getDetails(
                        $AppDetails.currency_details,
                        item.cus_currency,
                        "currency_symbol"
                        )+" "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </span>
                      <span v-else-if="column.field=='export_due_amount'">
                        {{ getDetails(
                        $AppDetails.currency_details,
                        item.cus_currency,
                        "currency_symbol"
                        )+" "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </span>
                      <span
                        v-else-if="column.field=='due_date'"
                      >{{ getDateFormat(item[column.field]) }}</span>
                      <span
                        :class="{'text':column.align=='overflow'}"
                        v-else
                      >{{item[column.field] }}</span>
                    </td>
                  </tr>
                </tbody>
              </template>
              <template v-if="lists.length >0">
                <tbody>
                  <tr>
                    <td colspan="5" class="fw-semi-bold text-right">TOTAL ({{total_count}})</td>

                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.total_view_value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.total_due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      v-if="reported_columns.length > 0 && show_columns_length > 0"
                      :colspan="parseInt(reported_columns.length) - 0"
                    ></td>
                  </tr>
                </tbody>
              </template>
            </table>
            <p class="ml-4" v-if="lists.length != 0">
              Amount is displayed in your base currency
              <b-badge variant="success" size="xs" style="height:20px">{{orgCurrency}}</b-badge>
            </p>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Sales by Item pagination and data showing -->
    <b-row
      v-if="lists.length > 0||arrow"
      style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
      class="px-pad"
    >
      <b-col xl="5" md="6" lg="6" sm="8" class="mt-2 pt-1 px-0">
        <nav v-if="lists.length > 0" class="float-left">
          <p>
            Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }}
            of {{ total_count }} entries
            <span
              class="btn-group dropdown"
            >
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                size="xs"
                :show="false"
                :text="count"
                left
              >
                <router-link
                  :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 10,select_columns:$route.query.select_columns,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,group_by:$route.query.group_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 25,select_columns:$route.query.select_columns,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,group_by:$route.query.group_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: 50,select_columns:$route.query.select_columns,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,group_by:$route.query.group_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                </router-link>
              </b-dropdown>
            </span> rows per page
          </p>
        </nav>
      </b-col>
      <b-col xl="2" md="2" lg="2" sm="4" style="text-align: center;" class="mt-2 pt-1 px-0">
        <div v-if="arrow">
          <a @click="left('#reportScrollCol')" class="mr-2">
            <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
          </a>
          <a @click="right('#reportScrollCol')">
            <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
          </a>
        </div>
      </b-col>
      <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
        <template v-if="show<total_count">
          <nav class="float-right">
            <ul class="pagination">
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,group_by:$route.query.group_by,sort:sort,label:label} }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,group_by:$route.query.group_by,sort:sort,label:label} }"
                >First</router-link>
              </li>
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,group_by:$route.query.group_by,sort:sort,label:label} }"
                  >Previous</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Previous</a>
                </template>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,group_by:$route.query.group_by,sort:sort,label:label } }"
                  >Next</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Next</a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: Math.ceil(total_count / count),show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,group_by:$route.query.group_by,sort:sort,label:label } }"
                >Last</router-link>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'AgingDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,filter_by:$route.query.filter_by,interval_range:$route.query.interval_range,number_of_columns:$route.query.number_of_columns,group_by:$route.query.group_by,sort:sort,label:label } }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </template>
              </li>
            </ul>
          </nav>
        </template>
      </b-col>
    </b-row>

    <!--  Model-->
    <!--  Model-->
    <b-modal
      id="AgingDetailsReport"
      title="Customize Report"
      body-class="bg-white"
      size="lg"
      ref="runreport"
      ok-title="Run Report"
      @ok.prevent="selectedfilter={},onRunReport(0)"
      cancel-variant="light"
      @shown="displayvalue()"
    >
      <!-- Validation for AgingDetailsReport reports -->
      <b-row>
        <b-col xl="12" lg="12" md="12" xs="12" sm="12">
          <div class="container-fluid">
            <b-alert class="alert-transparent alert-danger" :show="error_show && this.errors.any()">
              <p
                class="text-danger"
                v-if="errors.has('number_of_columns')"
              >Invalid value entered for aging range</p>
              <p
                class="text-danger"
                v-if="errors.has('interval_range')"
              >Invalid value entered for Interval range</p>

              <button type="button" @click="error_show=!error_show" class="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </b-alert>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-row>
            <b-col xl="12" lg="12" md="12" sm="12" xs="12">
              <b-form-group label="Date" label-for="date" :label-cols="2">
                <GlobalDateRangePicker
                  :singleDatePicker="true"
                  v-on:setDateRange="getDateRange($event)"
                  :fromDate="from_date"
                  :toDate="to_date"
                />
                <input type="hidden" name="from_date" v-model.trim="from_date" />
                <input type="hidden" name="to_date" v-model.trim="to_date" />
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <label class="control-label">Aging Intervals</label>
          <b-row>
            <b-col xl="4" lg="4" md="4" sm="4" xs="4">
              <select
                class="form-control"
                v-model.trim="field.number_of_columns"
                v-validate="'required'"
              >
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </select>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="6" xs="6">
              <div style="display:flex">
                <label class="control-label">intervals of</label>
                <b-input-group>
                  <input
                    class="form-control"
                    v-model.trim="field.interval_range"
                    @blur="field.interval_range = parseInt(field.interval_range) > 30 ? 15 : field.interval_range"
                    id="intervals"
                    type="text"
                    name="interval_range"
                    v-validate="'required|min_value:1|max_value:30|decimal:0'"
                  />
                  <!-- <b-input-group-append>
                  <b-dropdown text="Action" variant="success" style="height:30px">
                    <b-dropdown-item href="#">Days</b-dropdown-item>
                    <b-dropdown-item href="#">Weeks</b-dropdown-item>
                  </b-dropdown>
                  </b-input-group-append>-->
                </b-input-group>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="7" lg="7" md="7" sm="7" xs="7" @click="removecustomer($event)">
              <label class="control-label">Customer Name</label>
              <vue-bootstrap-typeahead
                @input="customerlist($event)"
                v-model="cus_detail_id"
                :id="'customer_search'"
                name="cus_detail_id[]"
                :data="field.customers"
                :class="{'customer_search':true}"
                :serializer="customer => customer.label"
                @hit="checkCustomer($event)"
                placeholder="Type to search customer"
                :ref="'cus_name_typeahead'"
              />
              <input type="text" class="form-control" v-model.trim="show_by" v-show="false" />
            </b-col>
            <b-col xl="5" lg="5" md="5" sm="5" xs="5">
              <b-form-group>
                <label>Group By</label>
                <b-form-select class="form-control" v-model.trim="group_by">
                  <option value="0"></option>
                  <option value="cus_id">Customer Name</option>
                  <option value="sales_person_id">Sales Person</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- <div class="footer">
        <b-row>
          <b-col xl="12" lg="12" md="12" sm="12">
            <b-button variant="primary" @click="onRunReport" class="float-right ml-3">Run Report</b-button>
            <b-button variant="default" @click="closeModal('runreport')" class="float-right">Cancel</b-button>
          </b-col>
        </b-row>
      </div>-->
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="custom_index"
      title="Customize Report"
      body-class="bg-white"
      cancel-variant="light"
      ok-title="Run Report"
      size="lg"
      @ok.prevent="selectedfilter={},onRunReport(0)"
      ref="run"
    >
      <b-row>
        <b-col>
          <p class="fw-semi-bold pl-2">General</p>
          <b-form-checkbox
            class="pt-1"
            v-model="show_columns"
            v-for="(group, index) in available_columns"
            v-if="group.Group=='customer'||group.Group=='general'||group.Group=='pymnt_terms'||group.Group=='credit_limit'||group.Group=='sales_person'||group.Group=='project'||group.Group=='gst_type'"
            :value=" {group:group.Group,field: group.field}"
            :key="index"
            @change="group.checked = !group.checked"
            style="display:block;padding-left:30px"
          >{{group.title}}</b-form-checkbox>
        </b-col>
        <b-col>
          <p class="fw-semi-bold pl-2">Aging Details</p>
          <b-form-checkbox
            class="pt-1"
            v-model="show_columns"
            v-for="(group, index) in available_columns"
            v-if="group.Group=='aging'"
            :value=" {group:group.Group,field: group.field}"
            :key="index"
            @change="group.checked = !group.checked"
            style="display:block;padding-left:25px"
          >{{group.title}}</b-form-checkbox>
        </b-col>
      </b-row>
    </b-modal>
    <SaveFilterForm :saveforfuture="saveforfuture" :page="filterpage" :item="filteritems" />
    <GlobalModal
      :content="content"
      :module="module"
      :title="title"
      :data="globalmodaldata"
      :isRoute="isRoute"
      :RoutePlace="RoutePlace"
      :type="globalmodaltype"
    />
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Aging Details'"
      @downloaded="export_modal=false"
    />
    <!--  back to top  -->
  </div>
</template>
<!-- Sales by Customer  Script -->
<script>
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll

import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import Vue from "vue";
import moment from "moment";
import $ from "jquery";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import { formatDate } from "@/mixins/formatDate";
import SaveFilterForm from "@/pages/Reports/SaveFilterForm";
function getPageAgingDetailsReport(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const sort = routeTo.query.sort || "";
  const label = routeTo.query.label || "";
  store
    .dispatch("reports/fetchAgingDetialLists", {
      page: currentPage,
      show: show,
      sort: sort,
      label: label,
      query: routeTo.query
    })
    .then(() => {
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.sort = sort;
      routeTo.params.label = label;
      next();
    });
}
export default {
  components: {
    VueBootstrapTypeahead,
    SaveFilterForm
  },
  mixins: [formatDate, scrollTable],
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },

    label: [String, Number],
    sort: [String, Number]
  },
  name: "AgingDetailsReport",
  data() {
    return {
      arrow: false,
      export_data: [],
      export_modal: false,
      export_xl: {
        Date: "created_date",
        INVOICE: "inv_no",
        Status: "inv_status_name",
        CUSTOMER: "cus_name",
        AGE: "age",
        AMOUNT: "grand_total",
        BALANCE: "due_amount"
      },
      show_columns: [],
      show_columns_length: 0,
      reported_columns: [],
      available_columns: [
        {
          Group: "customer",
          field: "cus_fname",
          title: "First Name",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "customer",
          field: "cus_lname",
          title: "Last Name",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "customer",
          field: "cus_comp_name",
          title: "Company Name",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "customer",
          field: "cus_legacy_id",
          title: "Customer ID",
          checked: false,
          colWidth: 150,
          align: ""
        },
        {
          Group: "customer",
          field: "cus_ph_no_1",
          title: "Phone",
          checked: false,
          colWidth: 110,
          align: ""
        },
        {
          Group: "customer",
          field: "cus_mail",
          title: "Mail",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "gst_type",
          field: "gst_type_name",
          title: "Gst Type",
          checked: false,
          colWidth: 210,
          align: ""
        },

        {
          Group: "customer",
          field: "cus_gst_no",
          title: "Gst No",
          checked: false,
          colWidth: 145,
          align: ""
        },
        {
          Group: "customer",
          field: "cus_pan_no",
          title: "Pan No",
          checked: false,
          colWidth: 115,
          align: ""
        },
        {
          Group: "customer",
          field: "place_of_supply",
          title: "Place of supply",
          checked: false,
          colWidth: 200,
          align: ""
        },
        {
          Group: "general",
          field: "cus_twitter_id",
          title: "Twitter id",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_facebook_id",
          title: "Facebook id",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_website",
          title: "Website",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_dept",
          title: "Designation",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_currency",
          title: "Currency",
          checked: false,
          colWidth: 180,
          align: ""
        },
        {
          Group: "pymnt_terms",
          field: "term_name",
          title: "Payment Term",
          checked: false,
          colWidth: 145,
          align: "overflow"
        },
        {
          Group: "credit_limit",
          field: "credit_limit",
          title: "Credit Limit",
          checked: false,
          colWidth: 180,
          align: "right"
        },
        {
          Group: "aging",
          field: "export_grand_total",
          title: "Total(FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "aging",
          field: "export_due_amount",
          title: "Due Amount(FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "aging",
          field: "due_date",
          title: "Due Date",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "sales_person",
          field: "sales_person_name",
          title: "Sales Person",
          checked: false,
          colWidth: 140,
          align: "right"
        }
      ],

      field: {
        interval_range: "15",
        number_of_columns: "4",
        customers: []
      },
      columns: this.$route.query.show_columns,
      group_by: 0,
      error_show: false,
      cus_detail_id: "",
      show_by: 0,
      items: [],
      from_date: this.formatDate(moment().startOf("month")),
      to_date: this.formatDate(moment().endOf("month")),
      Selected: "",
      org_name: this.$AppDetails.organization.comp_name || "",
      psort: this.sort,
      plabel: this.label,
      saveforfuture: {},
      filterpage: "create",
      filteritems: "",
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: "",
      datePickerReport: 0
    };
  },

  updated() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },

  methods: {
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      this.$root.$emit("bv::show::modal", "exportdata");
    },
    displayvalue() {
      if (this.show_by != 0) {
        this.$refs.cus_name_typeahead.inputValue = this.cus_detail_id;
        $("#customer_search input").addClass("mask");
        $("#customer_search .input-group").append(
          "<span class='la la-close p-2' id='customer_remove'></span>"
        );
        $("#customer_remove").css("position", "absolute");
        $("#customer_remove").css("right", "0");
      }
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const response = await store
        .dispatch("reports/fetchAgingDetialExportLists", {
          page: currentPage,
          show: show,
          sort: sort,
          label: label,
          query: this.$route.query
        })
        .then(() => {
          return this.export;
        });
      return response;
    },

    removecustomer(e) {
      if (e.target.matches("#customer_remove")) {
        $("#customer_search input").css("pointer-events", "all");
        $("#customer_search input").css("background-color", "#fff");
        $("#customer_search input").css("position", "");
        $("#customer_remove").remove();
        var cus_name = "cus_name_typeahead";
        this.$refs[cus_name].inputValue = "";
        this.show_by = "";
      }
    },
    checkCustomer(event) {
      $("#customer_search input").css("pointer-events", "none");
      $("#customer_search input").css("background-color", "#f7f7f7");
      $("#customer_search input").css("position", "relative");
      $("#customer_search .input-group").append(
        "<span class='la la-close p-2' id='customer_remove'></span>"
      );
      $("#customer_remove").css("position", "absolute");
      $("#customer_remove").css("right", "0");
      this.show_by = event.value;
    },
    customerlist(event) {
      if (event != "") {
        store.dispatch("general/fetchCustomerData", event).then(() => {
          this.field.customers = this.customer_filter_list;
        });
      }
    },
    getPresentValue(arr, prop, val) {
      var hasMatch = false;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = true;
          break;
        }
      }
      return hasMatch;
    },
    getSecondPresentValue(arr, prop, val, prop2, val2) {
      var hasMatch = false;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val && arr[i][prop2] == val2) {
          hasMatch = true;
          break;
        }
      }
      return hasMatch;
    },
    closeModal(id) {
      this.$refs[id].hide();
    },
    async savefilterform() {
      this.saveforfuture = await {
        to_date: this.to_date,
        show_columns: this.show_columns,
        from_date: this.from_date,
        label: this.label,
        sort: this.sort,
        available_columns: this.available_columns,
        group_by: this.group_by,
        cus_detail_id: this.cus_detail_id,
        interval_range: this.field.interval_range,
        number_of_columns: this.field.number_of_columns
      };
      await this.$root.$emit("bv::show::modal", "savefilterform");
    },
    runcustomreport(item) {
      this.selectedfilter = item;
      var filter_content = JSON.parse(item.filter_content);
      this.to_date = filter_content.to_date;
      this.from_date = filter_content.from_date;
      this.plabel = JSON.parse(JSON.stringify(filter_content.label));
      this.psort = JSON.parse(JSON.stringify(filter_content.sort));
      this.show_columns = filter_content.show_columns;
      this.group_by = filter_content.group_by;
      this.available_columns = filter_content.available_columns;
      this.cus_detail_id = filter_content.cus_detail_id;
      this.field.interval_range = filter_content.interval_range;
      this.field.number_of_columns = filter_content.number_of_columns;
      this.onRunReport(0);
    },
    //  delete whole invoice
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },
    onRunReport(runreport) {
      this.datePickerReport = 1;
      this.$validator.validateAll().then(result => {
        if (result) {
          if (runreport == 0 && this.$refs.daterangeupdate) {
            var child = this.$refs.daterangeupdate;
            child.checkConsole({
              startDate: this.from_date,
              endDate: this.to_date
            });
          }
          this.reported_columns = JSON.parse(
            JSON.stringify(this.available_columns)
          );
          this.show_columns_length = JSON.parse(
            JSON.stringify(this.show_columns)
          ).length;
          var group_by = this.group_by != 0 ? this.group_by : "";
          var value = this.show_by != 0 ? this.show_by : "";
          //To add export for selected columns
          for (var i = 0; i < this.reported_columns.length; i++) {
            if (this.reported_columns[i].checked == true) {
              this.export_xl[
                this.reported_columns[i].title
              ] = this.reported_columns[i].field;
            } else {
              delete this.export_xl[this.reported_columns[i].title];
            }
          }
          this.$router.push({
            name: this.$route.name,
            query: {
              report_date: this.to_date,
              filter_by: "",
              label: $.isEmptyObject(this.selectedfilter)
                ? this.label
                : this.plabel,
              sort: $.isEmptyObject(this.selectedfilter)
                ? this.sort
                : this.psort,
              select_columns: JSON.stringify({
                columns: JSON.stringify(this.show_columns)
              }),
              interval_range: this.field.interval_range,
              number_of_columns: this.field.number_of_columns,
              group_by,
              value
            }
          });
        } else {
          this.error_show = true;
        }
      });
    },
    getDateRange(event, runreport) {
      this.from_date = event.startDate;
      this.to_date = event.endDate;
      if (runreport == 1) {
        this.onRunReport(runreport);
      } else {
        this.datePickerReport = 1;
      }
    },
    changeSelectOption(field, value) {
      Vue.set(this, field, value);
    }
  },
  created() {
    if (!$.isEmptyObject(this.selectedfilter)) {
      this.runcustomreport(this.selectedfilter);
    } else if (
      Object.entries(this.$route.query).length === 0 &&
      this.$route.query.constructor === Object
    ) {
      this.$router.push({
        name: this.$route.name,
        query: {
          report_date: this.formatDate(moment()),
          select_columns: JSON.stringify({
            columns: JSON.stringify(this.show_columns)
          }),
          filter_by: "",
          interval_range: this.field.interval_range,
          number_of_columns: this.field.number_of_columns
        }
      });
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch(
      "general/getallcustomfilter",
      JSON.stringify({
        report_type: routeTo.meta.title
      })
    );
    getPageAgingDetailsReport(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    typeof this.$refs.runreport != "undefined"
      ? this.$refs.runreport.hide()
      : "";
    typeof this.$refs.run != "undefined" ? this.$refs.run.hide() : "";
    getPageAgingDetailsReport(routeTo, next);
  },
  computed: {
    ...mapState({
      customer_filter_list: state => state.general.customer_filter_list,
      lists: state => state.reports.lists,
      total_count: state => state.reports.total_count,
      count: state => state.reports.count,
      total_amount: state => state.reports.total_amount,
      group_total_amount: state => state.reports.group_total_amount,
      aging_group_total_amount: state => state.reports.aging_group_total_amount,
      export: state => state.reports.export,
      reportsfilter: state => state.general.reportsfilter
    }),
    selectedfilter: {
      get() {
        return this.$store.state.general.selectedfilter;
      },
      set(val) {
        this.$store.state.general.selectedfilter = val;
      }
    },
    ...mapGetters(["orgCurrencySymbol", "orgCurrency"])
  }
};
</script>

<!--  Sales by Customer style -->
<style scoped>
.pagination > .page-item > .page-link,
.pagination > .page-item > span {
  border-radius: unset;
  margin: 0;
  background: transparent;
}
.ver-align {
  padding-top: 10px;
  text-decoration: none;
}
.content {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  padding: 40px 40px 60px;
  background-color: #fff;
}
</style>